<template>
  <div>
    <h2 class="mb-6 text-uppercase text-center">
      Small Business
    </h2>
    <h4 class="mb-2">
      2 SubUsers | 40 Credits | 10Gb storage limit
    </h4>
    <ul class="mb-6">
      <li>Automated Document and Asset Registers</li>
      <li>Unlimited registry entries</li>
      <li>
        Self-generate unlimited digital smart contracts (subject to credit
        system)
      </li>
      <li>Upload any document for e-signature</li>
      <li>Collaborate with counterparties</li>
      <li>Request legal expert reviews</li>
      <li>Estate documents package</li>
      <li>Permissioned Subuser (trusted manager)</li>
      <li>Up to two authorised signatories</li>
      <li>Multiple business specific contracts</li>
      <li>Free Start-up document package</li>
      <li>Share Register</li>
    </ul>
    <p>
      Suit small business or start-up with limited need for initial low cost
      contracts and basic company registers
    </p>
  </div>
</template>
<script>
export default {
  name: 'SmallBusinessPlanDescription'
}
</script>
<style lang="sss" scoped></style>
